import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from 'src/core-modules/authentication/authentication.guard';
import { ShowMenuGuard } from 'src/core-modules/show-menu/showMenu.guard';
import { PrivateSalesListComponent } from './private-sales-list/private-sales-list.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        redirectTo: 'private-sale-list',
        pathMatch: "full"
      },
      {
        path: 'private-sale-list',
        component: PrivateSalesListComponent,
        data: { menu: "private-sales", submenu: "private-sale-list" },
        canActivate: [ShowMenuGuard]
      }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivateSalesRoutingModule { }
